export default __webpack_public_path__ + "static/media/a-to-z-worldwide.1ee27cf9.png";